var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { RadioButton, TextField } from "@folio/stripes/components";
import { useIntl } from "react-intl";
var PARITIES = ["ODD", "EVEN"];
export var BimonthlyEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("div", null,
        React.createElement(TextField, { type: "number", min: 1, max: 31, value: value.dayOfMonth, onChange: function (e) {
                var num = Math.max(1, Math.min(31, parseInt(e.target.value, 10) || 1));
                onChange(__assign(__assign({}, value), { dayOfMonth: num }));
            }, label: formatMessage({
                id: "ui-br-legaldeposits.schedule.bimonthly.dayOfMonth",
            }), disabled: disabled }),
        React.createElement("h4", null, formatMessage({
            id: "ui-br-legaldeposits.schedule.monthParity.label",
        })),
        PARITIES.map(function (parity) { return (React.createElement(RadioButton, { key: parity, name: "bimonthly-parity", label: formatMessage({
                id: "ui-br-legaldeposits.schedule.monthParity.".concat(parity),
            }), checked: value.monthParity === parity, onChange: function () { return onChange(__assign(__assign({}, value), { monthParity: parity })); }, disabled: disabled })); })));
};
